import { render, staticRenderFns } from "./CourseSchedule.vue?vue&type=template&id=3eb3769f&scoped=true&"
import script from "./CourseSchedule.vue?vue&type=script&lang=js&"
export * from "./CourseSchedule.vue?vue&type=script&lang=js&"
import style0 from "./CourseSchedule.vue?vue&type=style&index=0&id=3eb3769f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb3769f",
  null
  
)

export default component.exports